export default __webpack_public_path__ + "static/media/iam_student.e0cd3868.svg";